import { Button, Spinner } from '@iwoca/orion';

import { DISPLAY_TYPE_ENUM, TDisplayType } from './DrawDownModal';
import styles from './DrawDownModal.module.css';
import { IwocaToBankIllustration } from './IwocaToBankIllustration';
import SuccessCircle from '../../../../components/svg/SuccessCircle.svg';
import { useCurrentPayLink } from '../../hooks/useCurrentPayLink';

export const Success = ({
  finishDrawDown,
  displayType,
}: {
  finishDrawDown: () => void;
  displayType: TDisplayType;
}) => {
  const { payLink } = useCurrentPayLink();

  const getTitle = () => {
    if (!payLink) return 'Loading...';

    if (payLink?.capture_delay_hours)
      return `Sending ${payLink?.seller_name} confirmation...`;

    if (displayType === DISPLAY_TYPE_ENUM.OVERLAY)
      return 'Your payment is complete.';

    return `We've sent the payment to ${payLink?.seller_name}'s bank account`;
  };

  return (
    <>
      <div className={styles.title}>{getTitle()}</div>

      {displayType === DISPLAY_TYPE_ENUM.OVERLAY && (
        <div className={styles.subTitle}>
          You can now safely close this window and return to{' '}
          {payLink?.seller_name}.
        </div>
      )}

      <IwocaToBankIllustration
        icon={
          <span className={styles.processingDirectionError}>
            <img
              alt="Success"
              src={SuccessCircle}
              className={styles.SuccessCircleSVG}
            />
          </span>
        }
      />

      {displayType === DISPLAY_TYPE_ENUM.ECOMMERCE && (
        <div className={styles.subTitle}>
          <span className={styles.redirectText}>
            Redirecting you to the merchant...
          </span>
          <Spinner />
        </div>
      )}

      {displayType === DISPLAY_TYPE_ENUM.DEFAULT && (
        <Button
          variant="primary"
          className={styles.drawDownModalButton}
          onClick={finishDrawDown}
        >
          Go to the dashboard
        </Button>
      )}
    </>
  );
};
